import React from "react";
import { Tabs } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import LightFunnels from "./LightFunnels"; 
import LightFunnelsTokenTable from "./LightFunnelsTokenTable";

const LightFunnelsTabs = () => {
  const [_] = useTranslation("global");

  return (
    <Tabs defaultValue="gallery" className="w-100">
      <Helmet>
        <title>{_("panel.lightFunnels")}</title>
      </Helmet>
      <Tabs.List>
        <Tabs.Tab value="gallery" className="fs-5" color="rgb(89, 198, 201)">
          {_("panel.link")}
        </Tabs.Tab>
        <Tabs.Tab value="messages" className="fs-5" color="rgb(89, 198, 201)">
          {_("panel.keys")}
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="gallery">
        <LightFunnels />
      </Tabs.Panel>

      <Tabs.Panel value="messages">
        <LightFunnelsTokenTable />
      </Tabs.Panel>
    </Tabs>
  );
};

export default LightFunnelsTabs;
